import React from 'react';

import MuiFormHelperText, {
  FormHelperTextProps as MuiFormHelperTextProps,
} from '@mui/material/FormHelperText';
import clsx from 'clsx';

import { CoreProps } from '../types';
import { withCoreProps } from '../withCoreProps';

export const FormHelperText = withCoreProps<FormHelperTextProps>(
  ({
    children,
    className,
    ...props
  }: React.PropsWithChildren<FormHelperTextProps>) => {
    const clsxClass = clsx(className);

    return (
      <MuiFormHelperText {...props} className={clsxClass}>
        {children}
      </MuiFormHelperText>
    );
  },
);

export interface FormHelperTextProps
  extends MuiFormHelperTextProps,
    CoreProps {}
